<script setup lang="ts">
import type { MultiplaceGiftsContentVotes } from '@consumer/types/serializers'
import thumbsUpSolidIcon from '@consumer/assets/icons/new/thumbs-up-solid.svg?svgicon'
import thumbsUpLightIcon from '@consumer/assets/icons/new/thumbs-up-light.svg?svgicon'
import thumbsDownSolidIcon from '@consumer/assets/icons/new/thumbs-down-solid.svg?svgicon'
import thumbsDownLightIcon from '@consumer/assets/icons/new/thumbs-down-light.svg?svgicon'

withDefaults(defineProps<{ contentVote?: MultiplaceGiftsContentVotes }>(), {  })

const emit = defineEmits<{
  thumbsUpVote: []
  thumbsDownVote: []
  voteRemoved: []
}>()

const containerElement = ref<HTMLDivElement>()
const tempThumbValue = ref()

function thumbsDownClicked (evt: Event) {
  evt.stopPropagation()
  if (__props.contentVote == null) {
    tempThumbValue.value = 'thumbs_down'
    emit('thumbsDownVote')
  }
  else if (__props.contentVote.vote === 'thumbs_down') {
    tempThumbValue.value = null
    __props.contentVote.vote = ''
    emit('voteRemoved')
  }
  else if (__props.contentVote.vote === 'thumbs_up') {
    tempThumbValue.value = __props.contentVote.vote = 'thumbs_down'
    emit('voteRemoved')
    emit('thumbsDownVote')
  }
}

function thumbsUpClicked (evt: Event) {
  evt.stopPropagation()
  if (__props.contentVote == null) {
    tempThumbValue.value = 'thumbs_up'
    emit('thumbsUpVote')
  }
  else if (__props.contentVote.vote === 'thumbs_up') {
    tempThumbValue.value = null
    __props.contentVote.vote = ''
    emit('voteRemoved')
  }
  else if (__props.contentVote.vote === 'thumbs_down') {
    tempThumbValue.value = __props.contentVote.vote = 'thumbs_up'
    emit('voteRemoved')
    emit('thumbsUpVote')
  }
}

function toggleVotingUI () {
  containerElement.value?.classList.toggle('open')
}

const thumbsUpIcon = computed(() =>
  tempThumbValue.value === 'thumbs_up'
    || __props.contentVote?.vote === 'thumbs_up'
    ? thumbsUpSolidIcon
    : thumbsUpLightIcon)
const thumbsDownIcon = computed(() =>
  tempThumbValue.value === 'thumbs_down'
    || __props.contentVote?.vote === 'thumbs_down'
    ? thumbsDownSolidIcon
    : thumbsDownLightIcon)

watch(() => __props.contentVote, () => tempThumbValue.value = null)

</script>
<template>
  <div ref="containerElement" class="content-voting relative" :ontouchend="toggleVotingUI">
    <slot name="content"/>
    <div
      class="thumbs border rounded-md border-solid border-grey-500
                p-2 flex w-25 shadow absolute right-0 bottom-0
                bg-white"
      style="z-index: 1;"
    >
      <div
        ref="thumbsUpElement"
        data-testid="thumbs-up"
        class="flex-grow flex justify-center"
      >
        <GIcon
          :icon="thumbsUpIcon"
          size="24px"
          color="grey-500"
          class="flex-grow border-r-1 border-solid border-grey-500 clickable"
          @click="thumbsUpClicked"
          @touchend="thumbsUpClicked"
        />
      </div>
      <div
        data-testid="thumbs-down"
        class="flex-grow flex justify-center"
      >
        <GIcon
          :icon="thumbsDownIcon"
          size="24px"
          color="grey-500"
          class="clickable"
          @click="thumbsDownClicked"
          @touchend="thumbsDownClicked"
        />
      </div>
    </div>
  </div>
</template>
<style>
.content-voting .thumbs {
  display: none;
}

.content-voting:hover .thumbs,
.content-voting.open .thumbs {
  display: flex;
}
</style>
